import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import {
  Table, Row, Cell
} from '../../../components/table';
import { getRequest } from '../../../../../api/ApiService';

import { getProductRowColor, getProductNameColor } from '../../../../../api/PerformanceFeedback';

class MarketShareStep4 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      products: [],
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    getRequest(`${process.env.REACT_APP_API_URL}team/products/?round_lte=${activeRound}`)
      .then(res => {
        const products = res.body.filter(i => Number(i.round) === roundId);

        this.setState({
          products,
        });
      })
      .catch(err => { });
  }

  render() {
    const { products } = this.state;
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText="Demand Issue : No customer was interested in buying some or all of your product(s)."
        paragraph2={(
          <Fragment>
            To drive demand, you’ll need to build products that customers want and to understand customers'
            interest, conducting market research is critical.
          </Fragment>
        )}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff" />
              <Cell color="#ffffff">Resolution</Cell>
              <Cell color="#ffffff">Sensitivity</Cell>
              <Cell color="#ffffff">Power</Cell>
              <Cell color="#ffffff">Temp Range</Cell>
            </Row>
            {products.map((product, index) => (
              <Row background={getProductRowColor(index)} key={index}>
                <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{product.name}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.pixels_rank}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.sensitivity_rank}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.power_rank}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.temp_range_rank}</Cell>
              </Row>
            ))}
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }

}

export default MarketShareStep4;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step4.js